import React from "react";
import classNames from "classnames";
import styles from "./shot-map-shot-selector.module.scss";
import {observer} from "mobx-react";
import {ShotMapShotSelectorForward} from "./shot-map.shot-selector.forward";
import {ShotMapShotSelectorBackward} from "./shot-map.shot-selector.backward";
import {ShotMapShotSelectorContent} from "./shot-map.shot-selector.content";

export const ShotMapShotSelector = observer(({
                                               controller,
                                               selectedShot,
                                               onClick,
                                               shotsLength,
                                               shouldRenderTypeShot,
                                               isShallowShotMapView,
                                               shouldRenderPlayer
                                             }) => {
  if(shotsLength === 0 || selectedShot === null) {
    return null;
  }

  const {device: {isSmallView}} = controller;
  const shouldDisableArrows = shotsLength === 1;

  const arrowProps = {
    shouldDisableArrows,
    controller,
    onClick
  }

  const contentProps = {
    controller,
    selectedShot,
    shouldRenderTypeShot,
    isShallowShotMapView,
    shouldRenderPlayer
  }

  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView, [styles.single_container]: !shouldDisableArrows, [styles.shallow_shot_map]: isShallowShotMapView && shouldRenderPlayer})}>
      <ShotMapShotSelectorBackward {...arrowProps}/>
      <ShotMapShotSelectorContent {...contentProps}/>
      <ShotMapShotSelectorForward {...arrowProps}/>
    </div>
  )
});